export default "__VITE_ASSET__D$2Y6mDt__"